import { useAuth0 } from '@auth0/auth0-react'

import React from 'react'
import { useHistory } from 'react-router-dom'

import { isNativeApp } from '../config/auth0'
import { getLogoutOptions, prepareLogout } from '../utils/logout'

const Logout = (): JSX.Element => {
  const isMobileDevice = isNativeApp()
  const { logout, user } = useAuth0()
  const history = useHistory()

  prepareLogout(user?.sub)

  if (isMobileDevice) {
    // Since on a mobile device, the logout happens in a separate browser window leaving the app in its previous state,
    // we need to send them to the default route so that when they return after logging in, they are not still on a potentially private route
    history.push(`/`)
  }
  logout(getLogoutOptions())

  return <div>Logging out...</div>
}

export default Logout
